import React from 'react';
import Icon from '../../../components/AppIcon';
import {Button} from '../../../components/ui/Button';

const ProfileActions = ({ 
  isEditing, 
  onEditToggle, 
  onVerifyAccount, 
  onChangePassword, 
  isVerified = false 
}) => {
  return (
    <div className="flex items-center space-x-3">
      {/* Edit Profile Button */}
      <Button
        variant={isEditing ? "outline" : "default"}
        onClick={onEditToggle}
        iconName={isEditing ? "X" : "Edit"}
        iconPosition="left"
        size="sm"
      >
        {isEditing ? 'Cancel' : 'Edit Profile'}
      </Button>

      {/* Action Menu Dropdown */}
      <div className="relative">
        <details className="group">
          <summary className="inline-flex items-center px-3 py-2 border border-border rounded-md text-sm font-medium text-foreground bg-background hover:bg-muted focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring cursor-pointer">
            <Icon name="MoreVertical" size={16} />
          </summary>
          
          <div className="absolute right-0 mt-2 w-48 bg-popover border border-border rounded-md shadow-elevated z-10 group-open:block hidden">
            <div className="py-1">
              {!isVerified && (
                <button
                  onClick={onVerifyAccount}
                  className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-foreground hover:bg-muted transition-micro"
                >
                  <Icon name="Shield" size={16} />
                  <span>Verify Account</span>
                </button>
              )}
              
              <button
                onClick={onChangePassword}
                className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-foreground hover:bg-muted transition-micro"
              >
                <Icon name="Key" size={16} />
                <span>Change Password</span>
              </button>
              
              <button
                onClick={() => console.log('Two-factor authentication')}
                className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-foreground hover:bg-muted transition-micro"
              >
                <Icon name="Smartphone" size={16} />
                <span>Two-Factor Auth</span>
              </button>
              
              <button
                onClick={() => console.log('Connected accounts')}
                className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-foreground hover:bg-muted transition-micro"
              >
                <Icon name="Link" size={16} />
                <span>Connected Accounts</span>
              </button>
              
              <div className="border-t border-border my-1"></div>
              
              <button
                onClick={() => console.log('Activity log')}
                className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-foreground hover:bg-muted transition-micro"
              >
                <Icon name="Clock" size={16} />
                <span>Activity Log</span>
              </button>
              
              <button
                onClick={() => console.log('Download data')}
                className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-foreground hover:bg-muted transition-micro"
              >
                <Icon name="Download" size={16} />
                <span>Download Data</span>
              </button>
            </div>
          </div>
        </details>
      </div>

      {/* Verification Badge */}
      {isVerified && (
        <div className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-green-100 text-green-800">
          <Icon name="CheckCircle" size={14} className="mr-1" />
          Verified
        </div>
      )}
    </div>
  );
};

export default ProfileActions;